import React from 'react'
import ProfileImagesInput from 'components/ProfileImagesInput'

const ProfileImages = props => (
  <div className="w-full">
    <ProfileImagesInput {...props} />
  </div>
)

export default ProfileImages
